import { getSectionHeadingId } from '@/components/widget/visualizations/internal/utils';
import { Label, Input, Textarea } from '@/components/FormElements';
import RevealPill, { PillSwitch } from '@/components/Editor/Form/fields/RevealPill';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const EditorFormFieldsHeadings = _ref => {
  let {
    widgetId,
    sectionId,
    title,
    hasHeading: initialHasHeading,
    openButtonVariant,
    onChange
  } = _ref;
  const hasHeading = initialHasHeading || Boolean(title) && initialHasHeading !== false;
  return /*#__PURE__*/_jsx(RevealPill, {
    label: "Heading",
    openButtonVariant: openButtonVariant,
    disableOpen: true,
    activeState: /*#__PURE__*/_jsx(PillSwitch, {
      checked: hasHeading,
      onChange: checked => {
        const title = checked ? '' : null;
        const subHeading = checked ? '' : null;
        const tooltip = checked ? '' : null;
        onChange({
          hasHeading: checked,
          title,
          subHeading,
          tooltip
        });
        if (!checked) return; // Focus on the heading element after a short delay
        // to ensure it's visible and focused

        setTimeout(() => {
          const heading = document.getElementById(getSectionHeadingId(widgetId, sectionId));
          if (!heading) return;
          heading.focus();
        }, 300);
      }
    })
  });
};

const HeadingFields = _ref2 => {
  let {
    nameSpace,
    title,
    tooltip,
    onChange
  } = _ref2;
  const headingInputId = `${nameSpace}-heading`;
  const tooltipInputId = `${nameSpace}-tooltip`;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Label, {
      forInput: headingInputId,
      text: "Heading",
      className: parentStyles.formField,
      children: /*#__PURE__*/_jsx(Input, {
        id: headingInputId,
        placeholder: "Section description",
        defaultValue: title,
        onChange: evt => onChange({
          title: `${evt.target.value || ''}`.trim()
        }),
        onBlur: evt => {
          if (!evt.target.value.trim()) {
            onChange({
              title: null,
              tooltip: null
            });
          }
        }
      })
    }), /*#__PURE__*/_jsx(Label, {
      forInput: tooltipInputId,
      className: parentStyles.formField,
      text: "Heading Tooltip",
      caption: "Optional markdown text, revealed when user interacts with the header info icon.",
      children: /*#__PURE__*/_jsx(Textarea, {
        id: tooltipInputId,
        placeholder: "*about this* _section_",
        defaultValue: tooltip || '',
        onChange: evt => onChange({
          // @ts-ignore
          tooltip: `${evt.target.value || ''}`.trim() || null
        })
      })
    })]
  });
};

export default EditorFormFieldsHeadings;
export { HeadingFields };